import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { gameLayers } from "game-layers";
import { FowlSlotBonusResult } from "model/results/fowl-slot-bonus-result";
import { SlingoGameProgressResult } from "slingo/model/results/slingo-game-progress-result";
import { BigWinComponent } from "slotworks/components/bigwin/big-win-component";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export class FowlExitSlotBonusState extends State {
    public onEnter(cascadeSkip?: boolean): void {
        const totalStake = gameState.getCurrentGame().getLatestResultOfType(SlingoGameProgressResult).totalStake;

        const gameplay = gameState.getCurrentGame();
        const result = gameplay.getLatestResultOfType(FowlSlotBonusResult);
        if (gameplay.getFreespinsPlayed() === result.totalSpins) {
            result.played = true;
        }

        new Sequence([
            () => Services.get(SoundService).customEventContract("stop_bonus_music"),
            () => Components.get(BigWinComponent).showWin(this.getTotalSlotWin(), totalStake),
            () => gameLayers.ScreenFade.setScene("black"),
            () =>
                new Parallel([
                    () =>
                        Contract.wrap(() => {
                            uiFlags.set(UIFlag.FREE_SPINS, false);
                            uiFlags.set(UIFlag.NO_SKIP, false);
                            Components.get(MatrixComponent).change("default", [1, 1, 1, 1, 1], [0, 0, 0, 0, 0], slotDefinition.reelsets.get("slingo"));
                        }),
                    () => gameLayers.MatrixBackground.defaultScene(),
                    () => gameLayers.MatrixForeground.defaultScene(),
                    () => gameLayers.SymbolAnimations.defaultScene(),
                    () => gameLayers.Logo.defaultScene(),
                    () => gameLayers.BonusUI.defaultScene(),
                ]),
        ]).then(() => this.complete());
    }

    protected getTotalSlotWin(): number {
        let totalWin = 0;
        gameState
            .getCurrentGame()
            .getCurrentRecordParent()
            .children.forEach(record => {
                if (record instanceof FreespinRecord) totalWin += record.cashWon;
            });
        return totalWin;
    }
}
